module.exports = __webpack_public_path__ + "static/media/7.4c892e9e.jpg";